import identity from 'lodash/identity';
import * as types from '../../actions/actionTypes';
import addEstimateToSelection from './addEstimateToSelection';
import removeEstimateFromSelection from './removeEstimateFromSelection';
import initShareStore from './initShareStore';
import updateSignature from './updateSignature';

const actions = {
  [types.share.ADD_ESTIMATE]: addEstimateToSelection,
  [types.share.REMOVE_ESTIMATE]: removeEstimateFromSelection,
  [types.share.INIT_STORE]: initShareStore,
  [types.share.UPDATE_SIGNATURE]: updateSignature,
};

const initialState = {
  selection: [],
  signature: {
    name: '',
    email: '',
    phone: '',
    extension: '',
  },
};

export default (state = initialState, action) => (actions[action.type] || identity)(state, action);
